import { useStore } from "../../store";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import TemperatureChart from "../../components/TemperatureChart";
import { cToF } from "../../utils";
import DeviceControlItem from "../../components/DeviceControlItem";
import { BiXCircle } from "react-icons/bi";
import { useMemo } from "react";

function Diagnostic() {
  const { dataStore } = useStore();
  const resData = dataStore.resData;

  //初始化表格记录
  const records = { data: resData.runProgramRecordChartAck?.data || [] }

  if (resData.loadSettingAck?.temperatureUnit === 'F') {
    records.data = records?.data?.map(item => ({ ...item, temperature: Number(cToF(item.temperature)) }))
  }

  const chartRecord = useMemo(
    () => {
      return {
        temperature: records.data.map(item => ({ data: item.temperature, time: item.time })),
        humidity: records.data.map(item => ({ data: item.humidity, time: item.time })),
      }
    },
    [records.data] // 依赖 MobX 原始数组引用，只有它变才重新生成
  );

  const toggleCooler = (open: boolean) => {
    dataStore.sendData({
      action: 'toggleCooler',
      data: {
        open,
      },
    });
  }
  const toggleHeater = (open: boolean) => {
    dataStore.sendData({
      action: 'toggleHeater',
      data: {
        open,
      },
    });
  }
  const toggleLight = (open: boolean) => {
    dataStore.sendData({
      action: 'toggleLight',
      data: {
        open,
      },
    });
  }
  const toggleFans = (open: boolean) => {
    dataStore.sendData({
      action: 'toggleFans',
      data: {
        open,
      },
    });
  }
  const toggleDefroster = (open: boolean) => {
    dataStore.sendData({
      action: 'toggleDefroster',
      data: {
        open,
      },
    });
  }
  const toggleDoor = (open: boolean) => {
    dataStore.sendData({
      action: 'toggleDoor',
      data: {
        open,
      },
    });
  }
  const toggleDoorFrame = (open: boolean) => {
    dataStore.sendData({
      action: 'toggleDoorFrame',
      data: {
        open,
      },
    });
  }


  const emergencyStop = () => {
    toggleCooler(false)
    toggleHeater(false)
    toggleDefroster(false)
  }

  const closeDiagnostic = () => {
    dataStore.sendData({
      action: 'closeDiagnostic',
      data: {
      },
    });
  }


  const leftView = () => {
    return (
      <div
        className="flex"
        style={{
          flex: 1,
          borderRadius: 20,
          borderWidth: 1,
          borderColor: 'white',
          backgroundColor: '#E7A65E',
          flexDirection: 'column',
          position: 'relative',

        }}
      >
        <div
          style={{
            opacity: 0.9,
          }}
          className="text-white font-bold text-2xl text-center mt-10">CURRENT READINGS</div>

        <div
          style={{
            fontWeight: 700,
            color: 'white',
            textAlign: 'center',
            fontSize: 45,
            marginTop: 20,
          }}

        >Temperature:&nbsp;<span style={{
          minWidth: 180,
        }}>{resData.loadSettingAck?.temperatureUnit === '℉' ? cToF(resData.runProgramTemperatureAck?.temperature || 0) || '-' : resData.runProgramTemperatureAck?.temperature?.toFixed(1) || '-'}{resData.loadSettingAck?.temperatureUnit}</span></div>


        {resData.loadSettingAck?.humidityEnabled && (
          <div
            style={{
              width: '100%',
              textAlign: 'center',
              fontWeight: 700,
              color: 'white',
              fontSize: 35,
              marginTop: 10,
            }}
          >Humidity:&nbsp;<span style={{
            minWidth: 180,
          }}>{resData.runProgramTemperatureAck?.humidity?.toFixed(1) || "0.0"}%</span>
          </div>
        )}

        <div
          className="flex"
          style={{
            flex: 1,
            flexDirection: 'column',
            borderRadius: 10,
            margin: '10px 20px 20px 20px',
            // backgroundColor: '#FE9C1D',
            justifyContent: 'center',
            borderWidth: 5,
            borderColor: 'white',
          }}
        >

          <TemperatureChart
            dateFormat={resData.loadSettingAck?.dateFormat}
            unit={resData.loadSettingAck?.temperatureUnit as any}
            style={{
              width: '90%',
              height: resData.loadSettingAck?.humidityEnabled ? 160 : 340,
              marginTop: 30,
            }}
            records={chartRecord.temperature}
            XAxisTickFormatterTimeFormat={'DD HH:mm'}
          />


          {resData.loadSettingAck?.humidityEnabled && (
            <TemperatureChart
              dateFormat={resData.loadSettingAck?.dateFormat}
              XAxisTickFormatterTimeFormat={'DD HH:mm'}
              unit={'RH'}

              style={{
                width: '90%',
                height: resData.loadSettingAck?.humidityEnabled ? 160 : 340,
                marginTop: 30,
              }}
              records={chartRecord.humidity}
            />
          )}

        </div>

        <BiXCircle
          onClick={closeDiagnostic}
          style={{
            position: 'absolute',
            color: "#B1483D",
            fontSize: 70,
            margin: 10,
          }}
        />

      </div>
    )
  }


  const deviceControlListView = () => {

    const list = [
      { state: resData.loadNavStatusAck?.heater, title: 'HEATER', key: 'toggleHeater', onAction: (open: boolean) => toggleHeater(open) },
      { state: resData.loadNavStatusAck?.cooler, title: 'COOLER', key: 'toggleCooler', onAction: (open: boolean) => toggleCooler(open) },
      { state: resData.loadNavStatusAck?.fans, title: 'FANS', key: 'toggleFans', onAction: (open: boolean) => toggleFans(open) },
      { state: resData.loadNavStatusAck?.defroster, title: 'DEFROSTER', key: 'toggleDefroster', onAction: (open: boolean) => toggleDefroster(open) },
      { state: resData.loadNavStatusAck?.door, title: 'DOOR HEATER', key: 'toggleDoor', onAction: (open: boolean) => toggleDoor(open) },
      { state: resData.loadNavStatusAck?.doorFrame, title: 'DOOR FRAME', key: 'toggleDoorFrame', onAction: (open: boolean) => toggleDoorFrame(open) },
      { state: resData.loadNavStatusAck?.light, title: 'LIGHT', key: 'toggleLight', onAction: (open: boolean) => toggleLight(open) },
    ]

    return (
      <div
        className="flex"
        style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          padding: 15,
        }}
      >
        {list.map((item, key) => {
          return (
            <div
              key={key}
              style={{
                padding: 10,
                width: (list.length - 1 === key) ? list.length % 2 ? '100%' : '50%' : '50%',
              }}
            >
              <DeviceControlItem
                style={{
                  backgroundColor: 'white',
                  width: '100%',
                }}
                title={item.title} open={!!item.state} onOpen={item.onAction} />
            </div>

          )
        })}
      </div>
    )

  }

  const rightView = () => {
    return (
      <div
        className="flex"
        style={{
          marginLeft: 20,
          flex: 1,
          borderRadius: 20,
          borderWidth: 1,
          borderColor: 'white',
          backgroundColor: '#E7A65E',
          flexDirection: 'column'
        }}
      >
        <div
          className="flex mt-10"
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: "center",
            position: 'relative'

          }}
        >
          <div
            style={{
              opacity: 0.9,
            }}
            className="text-white font-bold text-2xl text-center"
          >
            DEVICE CONTROLS
          </div>
          <div
            style={{
              backgroundColor: '#B1483D',
              position: 'absolute',
              right: 10,
              padding: '5px 15px',
              borderRadius: 15,
              fontSize: 12,
              color: 'white',
              fontWeight: '600',
            }}
            onClick={emergencyStop}
          >
            EMERGENCY STOP
          </div>
        </div>

        <div
          className="flex"
        >
          {deviceControlListView()}
        </div>

      </div>
    )
  }


  return (
    <div className="flex">
      <div className="w-[1280px] h-[730px] flex">
        <div
          className="flex"
          style={{
            flex: 1,
            margin: 16,
            flexDirection: 'column',
          }}
        >
          <div style={{
            width: '100%',
            height: 3,
            backgroundColor: 'white',
          }} />
          <div style={{ height: 16, }} />

          <div
            className="flex"
            style={{
              flex: 1,
            }}
          >

            {/* 左侧 */}
            {leftView()}
            {/* 右侧 */}
            {rightView()}

          </div>
        </div>
      </div>

    </div>
  );
}
export default observer(Diagnostic);
